/* eslint-disable no-restricted-globals */

/* eslint-disable no-undef */
import React, { Suspense } from "react";
import { CircularProgress } from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import StAlbertLogo from "../assets/images/StAlbertLogo.png";
// var LuminateLogo = "https://sidmach.com/wp-content/uploads/2024/02/sidmach-logo-A.png";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { fetchJSON } from "helpers/axios";
// import

class ForgotPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      userMode: "",
      step: 1,
      formValues: {
        email: "",
      },
      devUrl: "http://localhost:3000/ConfirmNewPassword/",
      hostedUrl: "http://odfel-fedpolybida-api.azurewebsites.net/",
      rootUrl: "",
    };
  }

  componentDidMount() {
    if (this.props.userMode == "") {
      this.props.history.push("/");
      return false;
    } else {
      if (this.props.userMode == "Staff") {
        this.setState({
          userMode: "Admin",
        });
      } else {
        this.setState({
          userMode: this.props.userMode,
        });
      }
    }
  }

  getRootUrl = () => {
    let url = window.location.origin + "/portal/confirmnewpassword/";
    this.setState({ rootUrl: url });
    return url;
  };

  getBaseUrl = () => {
    let webUrl = this.getRootUrl();
    return webUrl === "http://localhost:22246/" ? devUrl : hostedApiUrl;
  };

  validateEmail = (e) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(e);
  };

  emailHandler = (e) => {
    try {
      let emailValue = document.getElementById("email").value;
      e.preventDefault();
      this.setState({ ...this.state, formValues: { email: emailValue } });
      let email = document.getElementById("email");
      if (!this.validateEmail(emailValue)) {
        email.style.color = "#d23f3f";
      } else {
        email.style.color = "green";
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred");
    }
  };

  sendLink = async () => {
    try {
      let model = {};
      let email = this.state.formValues.email;
      let link = this.getRootUrl();
      let resetLink = link; // this.state.devUrl;

      //this.getRootUrl();
      if (email == "") {
        NotificationManager.error("Email is required");
        return false;
      } else if (!this.validateEmail(email)) {
        NotificationManager.warning("Email is invalid");
        return false;
      } else {
        model = {
          email: email,
          userMode: this.props.userMode,
          step: 1,
          resetLink: `${resetLink}`,
        };
      }

      this.setState({ loader: true });
      const response = await fetchJSON(
        "api/Account/ForgotPassword",
        model,
        "POST"
      );
      if (response.Status == "Ok") {
        // (response);
        NotificationManager.success(response.Message, "Success");
      } else if (response.Status == "NotFound") {
        // (response);
        NotificationManager.error(response.Message);
      } else if (response.Status == "Invalid") {
        NotificationManager.error(response.Message);
      } else {
        NotificationManager.error(response.Message, response.Status);
      }
      this.setState({
        loader: false,
        formValues: {
          email: "",
        },
      });
    } catch (e) {
      this.setState({
        loader: false,
      });
      NotificationManager.error("An Error Occurred");
    }
  };

  render() {
    // const ForgotPassword = () => {
    const { width } = this.props;
    const { loader, userMode } = this.state;
    return (
      <div className="container">
        <div className="row login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
          <div className="col-md-4 login-content">
            <Suspense
              fallback={
                <div
                  className="loader-view"
                  style={{
                    height:
                      width >= 1200
                        ? "calc(100vh - 265px)"
                        : "calc(100vh - 245px)",
                  }}
                >
                  <CircularProgress />
                </div>
              }
            >
              <LoadingOverlay active={loader} spinner text="Loading...">
                <div className="login-header">
                  <Link
                    className=" app-logo d-flex align-items-center justify-content-center p-1"
                    to="/"
                    title="Jambo"
                  >
                    <img
                      src={StAlbertLogo}
                      alt="StAlbertLogo"
                      style={{ width: "150px", height: "144px" }}
                      title="StAlbertLogo"
                      className="img-fluid"
                    />
                  </Link>
                </div>

                <div className="mb-2">
                  <h3>
                    <IntlMessages id="appModule.enterAdminEmail" />
                  </h3>
                  <h5
                    className="d-flex align-items-center  p-0"
                    style={{ color: "#f9af16" }}
                  >
                    {" "}
                    Enter the email used for Registration.
                  </h5>
                </div>

                <div className="login-form">
                  <form method="post" action="/">
                    <TextField
                      type="email"
                      // id="required"
                      id="email"
                      label={<IntlMessages id="appModule.email" />}
                      fullWidth
                      value={this.state.formValues.email}
                      onChange={this.emailHandler}
                      margin="normal"
                      className="mt-0 mb-4"
                    />

                    {/* <p className="mb-3">
                  <IntlMessages id="appModule.dntRememberEmail" /> &nbsp;
                  <span className="small jr-link">
                    <IntlMessages id="appModule.contactSupport" />
                  </span>
                </p> */}

                    <div className="mb-3 d-flex align-items-center justify-content-between">
                      <Button
                        onClick={this.sendLink}
                        variant="contained"
                        style={{ backgroundColor: "#f9af16", color: "#ffffff" }}
                        className="text-white"
                      >
                        <IntlMessages id="appModule.send" />
                      </Button>

                      <Link to={`../${userMode}signin`}>
                        <IntlMessages id="appModule.signIn" />
                      </Link>
                    </div>
                  </form>
                </div>
              </LoadingOverlay>
            </Suspense>
          </div>
        </div>
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { userMode } = auth;
  return { userMode };
};

export default connect(mapStateToProps)(ForgotPassword);
